// extracted by mini-css-extract-plugin
export default {"editorContainer":"richTextEditor_editorContainer__yfHax"};